module.exports = __webpack_public_path__ + "static/media/howItWorks_step7.125a9eea.png";